// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 1200px) {
  .md-sect {
    margin-left: 1em !important;
    transform: scale(0.8);
  }
  .rf-sect {
    margin-left: 5em !important;
  }
  .App .App-body {
    min-width: 100% !important;
  }
  .wec0 {
    position: relative;
    width: 50vw;
    padding: 20px 50px;
  }
  .wec0 .mainh.b2 {
    font-size: 28px !important;
    line-height: 35px;
  }
  .App .bc-ma {
    width: 100% !important;
  }
  .wec1 {
    width: 50%;
    height: auto;
  }
  .wec1 .we1 {
    width: 50vw;
    height: auto !important;
  }
}
@media screen and (max-width: 999px) {
  .md-sect {
    display: none !important;
  }
  .rf-sect {
    margin-left: 0px !important;
  }
  .App .bc-ma {
    bottom: 115px !important;
  }
}
@media screen and (max-width: 900px) {
  .App .wec1, .bc-ro {
    display: none !important;
  }
  .mainh.b2 br {
    display: none !important;
  }
  .nobr br {
    display: none !important;
  }
  .App .wec0 {
    width: 100%;
  }
  .forwelp {
    width: 100% !important;
    padding: 50px 20px !important;
  }
  .App .App-body .gsv-cover {
    width: 100% !important;
  }
  .App .App-body .gsv-cover .gsv {
    width: 95% !important;
  }
  .App .App-body .gsv-cover p {
    width: 90% !important;
  }
  .App .pp-body.cn {
    padding-top: 40px;
  }
  .App .ssfy {
    display: block;
    text-align: center;
  }
}
@media screen and (min-width: 769px) {
  .for-mobile {
    display: none !important;
  }
  .not-mobile {
    display: inherit !important;
  }
}
@media screen and (max-width: 768px) {
  .for-mobile {
    display: inherit !important;
  }
  .not-mobile {
    display: none !important;
  }
  .anpi {
    font-size: 30px;
  }
  .btn.btn-success.trb {
    border-radius: 50%;
    padding: 15px;
    height: 40px;
    width: 40px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .card-body.for-table {
    overflow-y: auto;
  }
  .App-body .rf-sect, .App-body .md-sect {
    display: inline-flex;
    flex-direction: column;
  }
  .App-body .rf-sect.step-1, .App-body .md-sect.step-1 {
    width: 100% !important;
    padding: unset !important;
    border: 0px !important;
  }
  .App-body .sign-p {
    width: 100% !important;
    max-width: 100% !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
    text-align: center !important;
    font-size: 18px !important;
  }
}
@media screen and (max-width: 600px) {
  .App h1.mainh {
    font-size: 30px !important;
    line-height: 35px;
  }
  .App .wec0.alt {
    padding-left: 50px;
  }
  .App .App-body .rf-sect form, .rf-sect {
    width: 100% !important;
  }
  .App .App-body .rf-sect form .mainh, .rf-sect .mainh {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
  .rest-rect {
    width: 100% !important;
    padding: 30px 30px;
  }
  p.tcent {
    padding: 5px 0px;
  }
  .container, .wec0 {
    width: 90% !important;
    min-width: 90% !important;
  }
  .wec0 {
    padding: 0px;
  }
  .App .App-body {
    min-width: 90% !important;
  }
  .App .App-header.wel {
    padding-left: 50px !important;
  }
  .forwelp {
    width: 100% !important;
    padding: 50px 20px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Mobile.scss"],"names":[],"mappings":"AAAA;EACI;IACI,2BAAA;IACA,qBAAA;EACN;EACE;IACI,2BAAA;EACN;EACE;IACI,0BAAA;EACN;EAGE;IACI,kBAAA;IACA,WAAA;IACA,kBAAA;EADN;EAEM;IACI,0BAAA;IACA,iBAAA;EAAV;EAGE;IACI,sBAAA;EADN;EAGE;IACI,UAAA;IACA,YAAA;EADN;EAEM;IACI,WAAA;IACA,uBAAA;EAAV;AACF;AAIA;EACI;IACI,wBAAA;EAFN;EAIE;IACI,2BAAA;EAFN;EAIE;IACI,wBAAA;EAFN;AACF;AAKA;EACI;IACI,wBAAA;EAHN;EAMM;IACI,wBAAA;EAJV;EAQM;IACI,wBAAA;EANV;EASE;IACI,WAAA;EAPN;EAUE;IACI,sBAAA;IACA,6BAAA;EARN;EAYE;IACI,sBAAA;EAVN;EAYE;IACI,qBAAA;EAVN;EAYE;IACI,qBAAA;EAVN;EAaE;IACI,iBAAA;EAXN;EAaE;IACI,cAAA;IACA,kBAAA;EAXN;AACF;AAcA;EACI;IACI,wBAAA;EAZN;EAcE;IACI,2BAAA;EAZN;AACF;AAcA;EACI;IACI,2BAAA;EAZN;EAcE;IACI,wBAAA;EAZN;EAcE;IACI,eAAA;EAZN;EAcE;IACI,kBAAA;IACA,aAAA;IACA,YAAA;IACA,WAAA;IACA,eAAA;IACA,oBAAA;IACA,mBAAA;IACA,uBAAA;EAZN;EAcE;IACI,gBAAA;EAZN;EAkBM;IACI,oBAAA;IACA,sBAAA;EAhBV;EAiBU;IACI,sBAAA;IACA,yBAAA;IACA,sBAAA;EAfd;EAkBM;IACI,sBAAA;IACA,0BAAA;IACA,4BAAA;IACA,6BAAA;IACA,6BAAA;IACA,0BAAA;EAhBV;AACF;AAqBA;EACI;IACI,0BAAA;IACA,iBAAA;EAnBN;EAqBE;IACI,kBAAA;EAnBN;EAqBE;IACI,sBAAA;EAnBN;EAoBM;IACI,2BAAA;IACA,8BAAA;EAlBV;EAqBE;IACI,sBAAA;IACA,kBAAA;EAnBN;EAqBE;IACI,gBAAA;EAnBN;EAsBE;IACI,qBAAA;IACA,yBAAA;EApBN;EAsBE;IACI,YAAA;EApBN;EAsBE;IACI,yBAAA;EApBN;EAsBE;IACI,6BAAA;EApBN;EAsBE;IACI,sBAAA;IACA,6BAAA;EApBN;AACF","sourcesContent":["@media screen and (max-width: 1200px) {\n    .md-sect {\n        margin-left: 1em !important;\n        transform: scale(.8);\n    }\n    .rf-sect {\n        margin-left: 5em !important;\n    }\n    .App .App-body {\n        min-width: 100% !important;\n    }\n\n\n    .wec0 {\n        position: relative;\n        width: 50vw;\n        padding: 20px 50px;\n        .mainh.b2 {\n            font-size: 28px !important;\n            line-height: 35px;\n        }\n    }\n    .App .bc-ma {\n        width: 100% !important;\n    }\n    .wec1 {\n        width: 50%;\n        height: auto;\n        .we1 {\n            width: 50vw;\n            height: auto !important;\n        }\n    }\n}\n\n@media screen and (max-width: 999px) {\n    .md-sect {\n        display: none !important;\n    }\n    .rf-sect {\n        margin-left: 0px !important;\n    }\n    .App .bc-ma {\n        bottom: 115px !important;\n    }\n}\n\n@media screen and (max-width: 900px) {\n    .App .wec1, .bc-ro {\n        display: none !important;\n    }\n    .mainh.b2 {\n        br {\n            display: none !important;\n        }\n    }\n    .nobr {\n        br {\n            display: none !important;\n        }\n    }\n    .App .wec0 {\n        width: 100%;\n        // padding: 50px 50px;\n    }\n    .forwelp {\n        width: 100% !important;\n        padding: 50px 20px !important;\n    }\n\n\n    .App .App-body .gsv-cover {\n        width: 100% !important;\n    }\n    .App .App-body .gsv-cover .gsv {\n        width: 95% !important;\n    }\n    .App .App-body .gsv-cover p {\n        width: 90% !important;\n    }\n\n    .App .pp-body.cn {\n        padding-top: 40px;\n    }\n    .App .ssfy {\n        display: block;\n        text-align: center;\n      }\n}\n\n@media screen and (min-width: 769px) {\n    .for-mobile {\n        display: none !important;\n    }\n    .not-mobile {\n        display: inherit !important;\n    }\n}\n@media screen and (max-width: 768px) {\n    .for-mobile {\n        display: inherit !important;\n    }\n    .not-mobile {\n        display: none !important;\n    }\n    .anpi {\n        font-size: 30px;\n    }\n    .btn.btn-success.trb {\n        border-radius: 50%;\n        padding: 15px;\n        height: 40px;\n        width: 40px;\n        cursor: pointer;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .card-body.for-table {\n        overflow-y: auto;\n    }\n\n    \n\n    .App-body {\n        .rf-sect, .md-sect {\n            display: inline-flex;\n            flex-direction: column;\n            &.step-1 {\n                width: 100% !important;\n                padding: unset !important;\n                border: 0px !important;\n            }\n        }\n        .sign-p {\n            width: 100% !important;\n            max-width: 100% !important;\n            padding-left: 0px !important;\n            padding-right: 0px !important;\n            text-align: center !important;\n            font-size: 18px !important;\n        }\n    }\n\n}\n\n@media screen and (max-width: 600px) {\n    .App h1.mainh {\n        font-size: 30px !important;\n        line-height: 35px;\n    }\n    .App .wec0.alt {\n        padding-left: 50px;\n    }\n    .App .App-body .rf-sect form, .rf-sect {\n        width: 100% !important;\n        .mainh {\n            margin-top: 10px !important;\n            margin-bottom: 10px !important;\n        }\n    }\n    .rest-rect {\n        width: 100% !important;\n        padding: 30px 30px;\n    }\n    p.tcent {\n        padding: 5px 0px;\n    }\n\n    .container, .wec0 {\n        width: 90% !important;\n        min-width: 90% !important;\n    }\n    .wec0 {\n        padding: 0px;\n    }\n    .App .App-body {\n        min-width: 90% !important;    \n    }\n    .App .App-header.wel {\n        padding-left: 50px !important;\n    }\n    .forwelp {\n        width: 100% !important;\n        padding: 50px 20px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
